module.exports = __webpack_public_path__ + "static/img/tagtop3.31299f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tagtop3.png
// module id = SSsc
// module chunks = 1